import React from "react";
import DiffViewer from "@src/ui/DiffViewer"

/**
 * What this submission changed about the team's metadata, against the
 * submission before it.
 *
 * Three things can be true and each reads differently: there was nothing
 * before it, it changed nothing, or it changed something. Only the last is
 * worth two columns — the other two are one document, and splitting them puts
 * an empty pane beside it.
 */
const MetadataDiffView = ({ submission }: { submission: any }) => {
    const current = submission?.metadata ?? {};
    // an absent previous submission is not the same as an empty one: the first
    // submission a team makes has nothing behind it to compare against
    const previous = submission?.previous_metadata ?? null;

    const isFirst = previous === null;
    const changed = !isFirst && JSON.stringify(previous) !== JSON.stringify(current);

    return (
        <div className="sub-diff">
            <p className="sub-diff__note">
                {isFirst
                    ? "The first submission from this team — there is nothing before it to compare against."
                    : changed
                      ? "What this submission changed about the team's metadata."
                      : "This submission left the team's metadata as it was."}
            </p>

            <div className="sub-diff__body">
                <DiffViewer
                    leftTitle={changed ? "Before this submission" : undefined}
                    rightTitle={changed ? "After this submission" : "Metadata"}
                    oldValue={previous ?? current}
                    newValue={current}
                    splitView={changed}
                    format="yaml"
                    enableYaml
                />
            </div>
        </div>
    );
};

export default MetadataDiffView;
